import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Head from 'next/head';
import Header1 from '@/components/Header1';

interface Data {
  [key: string]: { secondLevel: string[]; amount: number[] };
}

const Pricing: React.FC = () => {
  const [options, setOptions] = useState<{ name: string; secondLevel: string[]; amount: number[] }[]>([]);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get('/api/data');
        const data: Data = response.data;

        const options = Object.entries(data).map(([name, { secondLevel, amount }]) => ({
          name,
          secondLevel,
          amount,
        }));

        setOptions(options);
      } catch (error) {
        console.error('Error fetching options:', error);
        setError('Error fetching options');
      }
    };

    fetchOptions();
  }, []);

  return (
    <main>
      <Header1 />
      <Head>
        <title>Pricing</title>
        <meta
          name="description"
          content="Buy cheap data bundles, airtime online for MTN, Glo, Airtel, and 9mobile, cable tv subscriptions, electricity bills payment, education pins. Swiftly process automated services from all service providers."
        />
        <meta
          name="keywords"
          content="cheap-data-bundles, buy-data, airtime, top-up, MTN, Glo, Airtel, 9mobile, etisalat, VTU, cable-tv, dstv, gotv, startimes, showmax, electricity-paymenets, prepaid-meter, postpaid-meter, ikedc, ekedc, aedc, kedco, phed, jed, kaedco, eedc, ibedc, bedc, education-payments, exam-pins, neco, waec, jamb, utme, nabteb"
        />
      </Head>

      <div className="flex flex-col items-center justify-center  min-h-screen mt-28">
        <h1 className="text-black text-3xl font-bold mb-8">Pricing</h1>
        <div className="container mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {options.map((option, index) => (
              <div key={index} className="rounded-lg shadow-md bg-white p-6">
                <h2 className="text-black text-lg font-semibold mb-4 text-center">{option.name}</h2>
                <ul>
                  {option.secondLevel.map((plan, i) => (
                    <li key={i} className="text-black flex justify-between items-center py-4">
                      <span>{plan}</span>
                      <span className="font-semibold">₦{option.amount[i]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Pricing;
